import { render } from "./ListCategorias.vue?vue&type=template&id=319136b3"
import script from "./ListCategorias.vue?vue&type=script&lang=js"
export * from "./ListCategorias.vue?vue&type=script&lang=js"

import "./ListCategorias.vue?vue&type=style&index=0&id=319136b3&lang=css"

import exportComponent from "C:\\Users\\btobia\\Documents\\ProyectosVSC\\marketvue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__